export default __webpack_public_path__ + "static/media/IMG_0426.72ec029b.jpg";